export var Agent;
(function (Agent) {
    Agent["GREETING"] = "greeting";
    Agent["FAQ"] = "faq";
    Agent["FALLBACK"] = "fallback";
})(Agent || (Agent = {}));
